import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
import { FIELD_NAME } from './constants';
export const GET_PORTAL_ALERT_FLAGS = registerQuery({
  fieldName: FIELD_NAME,
  fetcher() {
    return http.get('/forms/app/v1/alerts/check-portal-alert-flags');
  }
});